/**
 * TestimonialQuote — a small, lightweight social-proof block.
 *
 * Right now we have a single quote (Matt), so this is a single-card
 * component rather than a carousel. When we accumulate more
 * testimonials we'll promote this to a Carousel with the existing
 * shadcn/ui carousel primitive.
 *
 * Tone is intentionally calm and friendly — this matches the
 * supportive-tone style guide for the rest of the app.
 */
import React from 'react';
import { Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const QUOTES = [
  {
    id: 'matt-urban-dictionary',
    text: "It's like a professional version of urban dictionary haha I am here for it!",
    textEs:
      '¡Es como una versión profesional de Urban Dictionary, jaja, me apunto!',
    speaker: 'Matt',
  },
];

export const TestimonialQuote = () => {
  const { isSpanish } = useLanguage();
  const q = QUOTES[0]; // single-quote mode for now

  return (
    <section
      className="container max-w-3xl mx-auto px-4 py-8 sm:py-10"
      data-testid="landing-testimonial"
      aria-label={isSpanish ? 'Lo que la gente dice' : 'What people are saying'}
    >
      <div className="relative rounded-2xl border border-border bg-card p-6 sm:p-8 shadow-sm">
        <Quote
          className="absolute -top-3 left-6 h-7 w-7 text-[#00E5CC] bg-card px-1"
          aria-hidden="true"
        />
        <p
          className="text-base sm:text-lg leading-relaxed text-foreground italic"
          data-testid="landing-testimonial-text"
        >
          “{isSpanish ? q.textEs : q.text}”
        </p>
        <p className="mt-4 text-sm text-muted-foreground" data-testid="landing-testimonial-speaker">
          — {q.speaker}
        </p>
      </div>
    </section>
  );
};

export default TestimonialQuote;
